import { render } from "./JsonPagination.vue?vue&type=template&id=56a08ea6"
import script from "./JsonPagination.vue?vue&type=script&lang=js"
export * from "./JsonPagination.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/JsonPagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56a08ea6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56a08ea6', __exports__)) {
    console.log('reload')
    api.reload('56a08ea6', __exports__)
  }
  
  module.hot.accept("./JsonPagination.vue?vue&type=template&id=56a08ea6", () => {
    console.log('re-render')
    api.rerender('56a08ea6', render)
  })

}


export default __exports__